import React from "react";
import { Dropdown, Menu, MenuDivider, MenuItem } from "../components";
import "./demo-wrapper.scss";

const MenuWrapper = () => {
  return (
    <>
      <h1>📌 Menu</h1>
      <div className="demo-wrapper">
        <Menu>
          <MenuItem
            className="ddd"
            icon="Save"
            text="저장"
            onClick={() => {
              alert("ddd");
            }}
          />
          <MenuItem text="저장" />
          <MenuItem icon="Save" text="저장" label="ctrl+s" />
          <MenuItem icon="Save" text="저장" label="ctrl+s" disabled />

          <MenuDivider />
          <MenuItem icon="Save" text="저장">
            <MenuItem icon="Save" text="저장" label="ctrl+s" />
          </MenuItem>
          <MenuItem icon="Save" text="긴 글자는 어떻게 나오나요" label="ctrl+s">
            <MenuDivider title="자식" />
            <MenuItem icon="Save" text="저장" />
          </MenuItem>
          <MenuItem
            icon="Save"
            text="긴 글자는 어떻게 나오나요"
            label="ctrl+s"
            disabled
          >
            <MenuDivider title="자식" />
            <MenuItem icon="Save" text="저장" />
          </MenuItem>
        </Menu>
      </div>

      <div className="demo-wrapper">
        <h3>드롭다운 테스트</h3>
        <Menu className="dropdown">
          <Dropdown
            text="파일"
            children={
              <>
                <MenuItem icon="Save" text="저장">
                  <MenuItem icon="Save" text="저장" label="ctrl+s" />
                </MenuItem>
                <MenuItem
                  icon="Save"
                  text="긴 글자는 어떻게 나오나요"
                  label="ctrl+s"
                >
                  <MenuDivider title="자식" />
                  <MenuItem
                    icon="Save"
                    text="서브메뉴가 있는"
                    children={<MenuItem text="서브메뉴" />}
                  />
                </MenuItem>
              </>
            }
          />
          <Dropdown
            text="수정"
            children={
              <>
                <MenuItem icon="Save" text="저장" label="ctrl+s" />
              </>
            }
          />
          <Dropdown
            text="보기"
            children={
              <>
                <MenuItem icon="Save" text="저장" label="ctrl+s" />
              </>
            }
          />
        </Menu>
      </div>
    </>
  );
};

export default MenuWrapper;

